<template>
	<div class="playbooks-filter__search">
		<input
			:value="search"
			@input="updateSearch"
			@keydown.esc="clearSearch"
			placeholder="Search Playbooks..."
			type="text"
			class="omapi-input"
		/>
		<svg-times v-if="search" @click="clearSearch" class="clear-search" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { filtering } from 'optinmonster-js-library/src/vue/playbooks/mixins/filtering';

export default {
	mixins: [filtering],
	computed: {
		...mapState('playbooks', ['search']),
	},
	methods: {
		/**
		 * Sets the search in state to the current searching value
		 *
		 * @param {Object} e The event object
		 *
		 * @returns {void}
		 */
		updateSearch(e) {
			this.$store.commit('playbooks/setSearch', e.target.value);
		},
	},
};
</script>
